var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "social" },
    [
      _c("info_field", {
        attrs: {
          is_disabled: this.is_disabled,
          f_uniq: "fb_link",
          f_type: "fb_link",
          f_title: _vm.__t("FB_LINK"),
          f_val: _vm.social.fb_link,
        },
        on: { update_categ: _vm.change_atr },
      }),
      _vm._v(" "),
      _c("info_field", {
        attrs: {
          is_disabled: this.is_disabled,
          f_uniq: "insta_link",
          f_type: "insta_link",
          f_title: _vm.__t("INSTA_LINK"),
          f_val: _vm.social.insta_link,
        },
        on: { update_categ: _vm.change_atr },
      }),
      _vm._v(" "),
      _c("info_field", {
        attrs: {
          is_disabled: this.is_disabled,
          f_uniq: "youtube_link",
          f_type: "youtube_link",
          f_title: _vm.__t("YOUTUBE_LINK"),
          f_val: _vm.social.youtube_link,
        },
        on: { update_categ: _vm.change_atr },
      }),
      _vm._v(" "),
      _c("info_field", {
        attrs: {
          is_disabled: this.is_disabled,
          f_uniq: "tiktok_link",
          f_type: "tiktok_link",
          f_title: _vm.__t("TIKTOK_LINK"),
          f_val: _vm.social.tiktok_link,
        },
        on: { update_categ: _vm.change_atr },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }